import { HTMLProps, memo, useMemo } from 'react';
import { useColorType } from '../../libs';
import { ColorType, FontWeightType } from '../../types';
import styles from '../styles/HtsTypography.module.scss';

type HType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
type TextElemType = 'span' | 'p' | 'label';
type VariantType = 'body1' | 'body2' | 'caption' | 'button' | 'subtitle' | HType;

interface IHtsTypographyProps
  extends HTMLProps<HTMLHeadingElement & HTMLLabelElement & HTMLElement> {
  variant?: VariantType;
  element?: HType | TextElemType;
  color?: ColorType;
  fontWeight?: FontWeightType;
  dynamicColor?: string;
}

export const HtsTypography: React.FC<IHtsTypographyProps> = memo(
  ({
    variant = 'body1',
    element = 'p',
    color,
    fontWeight,
    children,
    className,
    style,
    dynamicColor,
    ...rest
  }) => {
    const Element = element;

    const colorType = useColorType(color) ?? dynamicColor ?? 'inherit';

    const variantClass = useMemo(
      (): Record<VariantType, string> => ({
        h1: 'H1',
        h2: 'H2',
        h3: 'H3',
        h4: 'H4',
        h5: 'H5',
        body1: 'Body1',
        body2: 'Body2',
        subtitle: 'Subtitle',
        button: 'Button',
        caption: 'Caption',
      }),
      []
    );

    const stylesVariant = { typography: styles[`typography${variantClass[variant]}`] };
    const elementClasses = [styles.typography, stylesVariant.typography, className].join(' ');

    return (
      <Element
        className={elementClasses}
        style={{ fontWeight, color: colorType, ...style }}
        {...rest}
      >
        {children}
      </Element>
    );
  }
);
